// extracted by mini-css-extract-plugin
export default {"nav-menu":"NavBar_nav-menu__XZCxm","nav-icon":"NavBar_nav-icon__LOg5Q","nav-list-item":"NavBar_nav-list-item__6iDC8","nav-icon-heart":"NavBar_nav-icon-heart__ZP35k"};